/*
 * Copyright (c) 2021. Dave van Rijn Development
 */

import React, {PureComponent, ReactElement} from 'react';
import DVRCarousel from "./DVRCarousel";
import {debug} from "../../..";

interface Props {
    children: ReactElement[];
    showControls: boolean;
    infinite: boolean;
    lazy: boolean;
    autoPlay: boolean;
    variableWidth: boolean;
    visibleItems?: number;
    slidePer: number;
    autoPlayInterval: number;
    className: string;
}

interface State {
    currentIndex: number;
}

export default class DVRCarouselController extends PureComponent<Props, State> {
    static defaultProps = {
        showControls: true,
        infinite: true,
        lazy: true,
        autoPlay: false,
        variableWidth: true,
        autoPlayInterval: 3000,
        className: '',
        slidePer: 1,
    }

    state: State = {
        currentIndex: 0,
    };

    private playTimeout: number | null = null;

    onClickNext = () => {
        const {children, slidePer} = this.props, {currentIndex} = this.state;
        let nextIndex = currentIndex + slidePer;
        if (currentIndex + this.getActualVisibleItems() > children.length) nextIndex = 0;
        this.setState({currentIndex: nextIndex});
    };

    onClickPrev = () => {
        const {slidePer} = this.props, {currentIndex} = this.state;
        this.setState({currentIndex: Math.max(0, currentIndex - slidePer)});
    };

    getActualVisibleItems = (): number => {
        const {visibleItems, children} = this.props;
        return visibleItems === undefined ? Math.min(children.length, 3) : visibleItems;
    };

    play = () => {
        const {autoPlayInterval} = this.props;
        this.playTimeout = window.setTimeout(this.slide, autoPlayInterval);
    };

    stop = () => {
        if (this.playTimeout !== null) {
            window.clearTimeout(this.playTimeout);
            this.playTimeout = null;
        }
    };

    slide = () => {
        this.onClickNext();
        if (this.props.autoPlay) this.play();
    }

    componentDidMount = () => {
        if (this.props.autoPlay) this.play();
    };

    componentWillUnmount = () => {
        this.stop();
    }

    render = () => {
        const {currentIndex} = this.state, {variableWidth, lazy, className, showControls, infinite, children} = this.props;
        return (
            <DVRCarousel onClickNext={this.onClickNext} onClickPrev={this.onClickPrev} currentIndex={currentIndex}
                         visibleItems={this.getActualVisibleItems()} lazy={lazy} className={className}
                         showControls={showControls} variableWidth={variableWidth}
                         infinite={infinite}>{children}</DVRCarousel>
        )
    };
}